import { Link } from 'react-router-dom';

export default function BlogCTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl overflow-hidden relative">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://readdy.ai/api/search-image?query=Modern%20lifestyle%20flatlay%20with%20open%20notebook%20pen%20smartphone%20and%20stylish%20fashion%20accessories%20neatly%20arranged%20on%20light%20marble%20surface%2C%20warm%20natural%20sunlight%20creating%20soft%20shadows%2C%20minimalist%20aesthetic%2C%20cream%20and%20sand%20tones%2C%20clean%20elegant%20composition%2C%20editorial%20photography%2C%20peaceful%20productive%20atmosphere%2C%20curated%20product%20display%2C%20sophisticated%20casual%20style&width=1200&height=500&seq=blog-cta-vigorbuy-new-16&orientation=landscape)',
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/30 to-black/20"></div>

          <div className="relative z-10 p-8 md:p-14 flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 text-xs font-medium mb-4">
                In-Depth Guide
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                The Complete Vigorbuy Spreadsheet Guide
              </h2>
              <p className="text-sm md:text-base text-background-50/85 max-w-lg">
                Dive deep into our comprehensive 2026 guide covering everything from getting 
                started to advanced shopping strategies. Learn how to find the best products, 
                verify quality with QC photos, and shop with total confidence.
              </p>
            </div>
            <Link
              to="/blog/vigorbuy-spreadsheet-ultimate-guide"
              className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold rounded-full bg-background-50 text-foreground-900 hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer flex-shrink-0"
            >
              Read the Full Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}